const PENDING_RECORDING_KEY = 'pending_recording_redirect';

export const savePendingRecordingRedirect = (recordId: string): void => {
  sessionStorage.setItem(PENDING_RECORDING_KEY, recordId);
};

export const peekPendingRecordingRedirect = (): null | string => {
  return sessionStorage.getItem(PENDING_RECORDING_KEY);
};

export const clearPendingRecordingRedirect = (): void => {
  sessionStorage.removeItem(PENDING_RECORDING_KEY);
};
